import { formatDate } from './dateHelpers';

// How a dynamic modification stage reads on screen: what it does and how strict it is.

export const STAGE_KIND = {
  INSPECT: 'inspect',
  SKIP: 'skip',
};

// levelShift moves along the AQL level scale (II to III checks more pieces),
// defectShift along the AQL values (2.5 to 1.5 accepts fewer defects).
export const STRICTNESS_OPTIONS = [
  { value: '0:0', label: 'Normal' },
  { value: '1:0', label: 'Tightened: check more pieces' },
  { value: '0:1', label: 'Tightened: accept fewer defects' },
  { value: '1:1', label: 'Tightened: both' },
  { value: '-1:0', label: 'Reduced: check fewer pieces' },
  { value: '0:-1', label: 'Reduced: accept more defects' },
  { value: '-1:-1', label: 'Reduced: both' },
];

export const strictnessOf = (stage) => {
  const value = `${stage.levelShift || 0}:${stage.defectShift || 0}`;
  return (
    STRICTNESS_OPTIONS.find((option) => option.value === value) || {
      value,
      label: `Custom (level ${stage.levelShift}, AQL ${stage.defectShift})`,
    }
  );
};

export const stageLabel = (stage) => {
  if (stage.kind === STAGE_KIND.SKIP) return 'Skip';
  return strictnessOf(stage).label.split(':')[0];
};

export const stageTone = (stage) => {
  if (stage.kind === STAGE_KIND.SKIP) return 'skip';
  const total = Number(stage.levelShift || 0) + Number(stage.defectShift || 0);
  if (total > 0) return 'tightened';
  if (total < 0) return 'reduced';
  return 'normal';
};

/** How far a product and factory pair is through its current stage, in words. */
export const stageProgress = ({ stage, passStreak, failStreak, skipsUsed, skipEndsAt }) => {
  if (stage.kind === STAGE_KIND.SKIP) {
    const parts = [];
    if (stage.skipCount) parts.push(`${skipsUsed} of ${stage.skipCount} inspections skipped`);
    if (skipEndsAt) parts.push(`asked again by ${formatDate(skipEndsAt)} at the latest`);
    return parts.join(', ');
  }
  if (stage.okCount) return `${passStreak} of ${stage.okCount} passes in a row`;
  if (failStreak) return `${failStreak} fail${failStreak === 1 ? '' : 's'} in a row`;
  return 'Stays here until a fail';
};
